import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  class: "alert alert-danger text-dark",
  role: "alert"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "modal-footer" }

import { computed, toRef } from 'vue'
    import type { AttributeDeleterDialogViewModel } from '@Alternatives/Attributes/Components/AttributeDeleterDialog'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AttributeDeleterDialog',
  props: {
    viewModel: {}
  },
  emits: ["delete-attribute", "show-dependencies"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value.opened)
    const initialized = computed(() => vm.value.rm != null)

    const attributeName = computed(() => vm.value.attributeName)
    const hasDependants = computed(() => vm.value.rm?.HasDependants ?? true)
    const dependenciesCount = computed(() => vm.value.rm?.Count ?? null)

    // ---------------- methods ----------------

    function emitDeleteAttribute()
    {
        emit('delete-attribute', vm.value.attributeId)
    }

    function emitShowDependencies()
    {
        emit('show-dependencies', vm.value.attributeId)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["modal-header", {'bg-danger': !hasDependants.value }])
              }, [
                _createElementVNode("h5", _hoisted_5, "Delete attribute: " + _toDisplayString(attributeName.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ], 2 /* CLASS */),
              _createElementVNode("div", _hoisted_6, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_7, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Checking dependencies... ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value && hasDependants.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "alert-heading" }, "Cannot delete this attribute", -1 /* CACHED */)),
                        _createElementVNode("p", null, [
                          _cache[1] || (_cache[1] = _createTextVNode(" The attribute '", -1 /* CACHED */)),
                          _createElementVNode("strong", null, _toDisplayString(attributeName.value), 1 /* TEXT */),
                          _cache[2] || (_cache[2] = _createTextVNode("' is used in ", -1 /* CACHED */)),
                          _createElementVNode("strong", null, _toDisplayString(dependenciesCount.value), 1 /* TEXT */),
                          _cache[3] || (_cache[3] = _createTextVNode(" places. To delete this attribute, first remove it from where it is used. ", -1 /* CACHED */))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (initialized.value && !hasDependants.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _cache[7] || (_cache[7] = _createElementVNode("h4", null, "Are you sure you want to delete this attribute?", -1 /* CACHED */)),
                      _createElementVNode("p", null, [
                        _cache[5] || (_cache[5] = _createTextVNode("You are about to delete '", -1 /* CACHED */)),
                        _createElementVNode("strong", null, _toDisplayString(attributeName.value), 1 /* TEXT */),
                        _cache[6] || (_cache[6] = _createTextVNode("'. This can't be undone.", -1 /* CACHED */))
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                (initialized.value && hasDependants.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-secondary",
                      onClick: emitShowDependencies
                    }, "View dependencies"))
                  : _createCommentVNode("v-if", true),
                (initialized.value && !hasDependants.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-danger",
                      onClick: emitDeleteAttribute
                    }, "Delete"))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: close
                }, "Cancel")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})